import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ga--product-show"
export default class extends Controller {
  static targets = ['product']

  connect() {
    if (this.hasProductTarget && typeof window.gtag === "function") {
      // item_id must be the PRODUCT id here, and in add_to_cart, view_cart and
      // purchase. Mixing product and variant ids splits one product into two
      // rows GA4 cannot join, which reads as "add_to_cart sends no item data".
      gtag('event', 'view_item', {
        currency: 'USD',
        value: this.ga_value,
        items: this.ga_item_list,
      })
      // event_id belongs in the third argument, not the properties: the pixel
      // reads the dedupe key from the options object only. In properties it is
      // just an inert custom property, and this event never merges with the
      // server-side one from TiktokEventsApiJob.
      ttq.track('ViewContent', {
        content_type: 'product',
        contents: this.tt_item_list,
      }, {
        event_id: this.requestId,
      })
    }
  }

  // Read from the layout rather than a data attribute on this element: this
  // controller renders inside a 6-hour fragment cache, so an attribute here
  // would carry the first visitor's request id to everyone after them and the
  // event would never match its server-side twin.
  get requestId() {
    return document.querySelector('meta[name="request-id"]')?.content || ''
  }

  get ga_value() {
    return this.productTargets.reduce((sum, prod) => sum + (parseFloat(prod.dataset.price) || 0), 0)
  }

  get ga_item_list() {
    let items = this.productTargets.map((prod, i) => {
      return {
        item_id: prod.dataset.id,
        item_name: prod.dataset.name,
        price: parseFloat(prod.dataset.price) || 0,
        quantity: 1,
        item_category: prod.dataset.mainType,
        item_category2: prod.dataset.subType,
      }
    })

    return items
  }

  get tt_item_list() {
    let items = this.productTargets.map((prod, i) => {
      return {
        content_id: prod.dataset.id,
        content_name: prod.dataset.name,
      }
    })

    return items
  }
}
